import {
	Actions,
	IActionResponse,
	IActionRequest,
	IResponseAuth,
	IActionChecking,
	IActionChecked
} from './Types';
import { ICredencial, IPassword, Recovery } from '../../Models/Security';
import { Dispatch } from 'redux';
import ServiceWrapper from '../../Services/ServiceWrapper';
import ServiceSession from '../../Services/ServiceSession';
import { createActionFetchProfile } from '../Profile/Actions';
import { IFaena, Producer } from './../../Models/Report';
import { createActionFetchPort, createActionSetProducers, createActionFetchStageData } from '../Report/Actions';
import { EStatusRequest } from '../../Reducers/Session';
import Notification from 'antd/lib/notification';

const service = new ServiceSession();

const actionChecking: IActionChecking = {
	type: Actions.CHECKING_TOKEN
};

const keyToken = 'session.token';

export const createActionChecking = () => {
	return (dispatch: any) => {
		dispatch(actionChecking);
		const token = sessionStorage.getItem(keyToken);
		const isSuccess = token !== undefined && token !== null && token !== '';
		dispatch({
			type: Actions.CHECKED_TOKEN,
			payload: {
				isAuth: isSuccess,
				token: token
			}
		} as IActionChecked);
		if (isSuccess) {
			ServiceWrapper.setToken(token as string);
			createActionAccount(dispatch);
		}
	};
};

export const createActionFetchFaenas = (id: number, includeSummary: boolean = true) => {
	return (dispatch: any) => {
		service
			.fetchFaenas(id)
			.then(async r => {
				const data: IFaena[] = await r.json();
				const producers: Producer[] = Producer.transform(data, id, createActionFetchPort, dispatch, includeSummary);
				dispatch({
					type: Actions.FETCH_FAENAS,
					payload: producers
				});
				dispatch(createActionSetProducers(producers));
				if (includeSummary) {
					producers.map(p => {
						dispatch(createActionFetchStageData(id, p))
						return null;
					});
				}
			})
			.catch(e => {
				dispatch({ type: Actions.FETCH_FAENAS, payload: [] });
			});
	};
};

export const createActionLogout = () => {
	return (dispatch: any) => {
		service.logout()
		.then(() => {
			sessionStorage.removeItem(keyToken);
			dispatch({
					type: Actions.CHECKED_TOKEN,
					payload: {
						isAuth: false,
						token: undefined
					}
				}
			);
			window.location.reload();
		})
		.catch(() => {
			window.location.reload();
		})
	}
}

export const createActionAccount = (dispatch: any) => {
	service
		.me()
		.then(async r => {
			const account = await r.json();
			dispatch(createActionFetchProfile(account.idProfile));
			dispatch({
				type: Actions.INIT_SESSION,
				payload: account
			});
		})
		.catch(() => {
			dispatch({
				type: Actions.CHECKED_TOKEN,
				payload: {
					isAuth: false,
					token: undefined
				}
			});
		});
};

export const createActionRequest: () => IActionRequest = () => ({
	type: Actions.REQUEST_TOKEN
});

export const createActionResponseAuth: (
	res: IResponseAuth
) => IActionResponse = (res: IResponseAuth) => ({
	type: Actions.RESPONSE_TOKEN,
	payload: res
});

export const createActionAuthenticate = (credential: ICredencial) => {
	return (dispatch: Dispatch<IActionRequest | IActionResponse>) => {
		dispatch(createActionRequest());
		service
			.login(credential)
			.then(async r => {
				const data = await r.json();
				dispatch(
					createActionResponseAuth({
						message: data.message.replace('Invalid Username or Password', 'Correo o Contraseña Inválidos' ),
						isAuth: data.result === 0,
						token: data.token
					})
				);
				if (data.alert) {
					Notification.error({
						description: "Su actividad se ha detectado como sospechosa",
						message: "Alerta"
					});
				}
				if (data.token) {
					ServiceWrapper.setToken(data.token);
					sessionStorage.setItem(keyToken, data.token);
					createActionAccount(dispatch);
				}
			})
			.catch(e => {
				dispatch(createActionResponseAuth(e));
			});
	};
};

export const createActionStatus = (status: EStatusRequest) => ({
	type: Actions.STATUS_SESSION,
	payload: status
});

export const createActionError = (data: any) => ({
	type: Actions.ERROR_SESSION,
	payload: data
})

export const createActionChangePassword = (password: IPassword) => {
	return (dispatch: any) =>  {
		dispatch(createActionRequest());
		dispatch(createActionStatus(EStatusRequest.PROCESS));
		service.changePassword(password)
			.then(async r => {
				if (r.ok) {
					dispatch(createActionStatus(EStatusRequest.COMPLETE));
				} else {
					dispatch(createActionError(await r.json()));
					dispatch(createActionStatus(EStatusRequest.FAIL));
				}
			})
			.catch((e: any) => {
				dispatch(createActionError(e));
				dispatch(createActionStatus(EStatusRequest.FAIL));
			});
	}
}

export const createActionRecovery = (data: Recovery) => {
	return (dispatch: any) => {
		dispatch(createActionStatus((EStatusRequest.PROCESS)));
		service.recoveryReq(data)
			.then(r => {
				if (r.ok) {
					dispatch(createActionStatus((EStatusRequest.COMPLETE)));
				} else {
					dispatch(createActionStatus((EStatusRequest.FAIL)));
				}
			})
			.catch(e => {
				dispatch(createActionStatus((EStatusRequest.FAIL)));
			})
	}
}

export const createActionRecoveryPass= (data: any) => {
	data.passwordCurrent = "**";
	return (dispatch: any) => {
		dispatch(createActionStatus((EStatusRequest.PROCESS)));
		service.recoveryPass(data)
			.then(r => {
				if (r.ok) {
					dispatch(createActionStatus((EStatusRequest.COMPLETE)));
				} else {
					dispatch(createActionStatus((EStatusRequest.FAIL)));
				}
			})
			.catch(e => {
				dispatch(createActionStatus((EStatusRequest.FAIL)));
			})
	}
}

export default {
	auth: createActionAuthenticate,
	checking: createActionChecking
};
